import { AxiosResponse } from 'axios';
import { JTLCredentials, CreateJTLCredentialsDTO } from '../types';
import { client } from './axiosClient';

export const getJTLCredentials = async (company_id: string | undefined) => {
  const res = await client.get<JTLCredentials>('/jtl/credentials', {
    params: {
      company_id,
    },
  });
  return res.data;
};

export const postJTLCredentials = async (company_id: string | undefined) => {
  const res = await client.post<
    undefined,
    AxiosResponse<CreateJTLCredentialsDTO>
  >('/jtl/credentials', undefined, {
    params: {
      company_id,
    },
  });
  return res.data;
};

export const regenerateJTLCredentials = async (
  company_id: string | undefined
) => {
  const res = await client.post<
    undefined,
    AxiosResponse<CreateJTLCredentialsDTO>
  >('/jtl/credentials/regenerate', undefined, {
    params: {
      company_id,
    },
  });
  return res.data;
};
